var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8382 24.0921C47.5013 23.4289 48.5726 23.4289 49.2357 24.0921L49.2527 24.0751C49.9159 24.7382 49.9159 25.8095 49.2527 26.4726L29.5624 46.1629C29.2223 46.486 28.7973 46.656 28.3552 46.656C27.9131 46.656 27.488 46.503 27.1479 46.1629L21.2476 40.2626C20.5845 39.5995 20.5845 38.5282 21.2476 37.8651C21.9107 37.2019 22.982 37.2019 23.6451 37.8651L28.3552 42.5751L46.8382 24.0921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.25 35.125C70.25 54.455 54.58 70.125 35.25 70.125C15.92 70.125 0.25 54.455 0.25 35.125C0.25 15.795 15.92 0.125 35.25 0.125C54.58 0.125 70.25 15.795 70.25 35.125ZM68.25 35.125C68.25 53.3504 53.4754 68.125 35.25 68.125C17.0246 68.125 2.25 53.3504 2.25 35.125C2.25 16.8996 17.0246 2.125 35.25 2.125C53.4754 2.125 68.25 16.8996 68.25 35.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.fe9984f4b7d12f1ebf7f27b9c5448e42.svg";
export { ForwardRef as ReactComponent };